// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MhGIN {\n  width: 33.33333%;\n}\n\n._3NSvX {\n  overflow: auto;\n}\n\n._6ZLaK {\n  width: 83%;\n}\n\n.TLwDt {\n  width: 200px;\n  height: 200px;\n  border-radius: var(--schoolinks-container-border-radius-medium);\n}\n\n.WkvFb {\n  font-weight: var(--font-weight-roboto-medium);\n  margin-bottom: var(--spacing-xxs);\n}\n\n@media screen and (max-width: 1020px) {\n  .MhGIN {\n    width: 100%;\n  }\n\n  .Ir5WH {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n}\n\n@media screen and (max-width: 560px) {\n  ._6ZLaK {\n    width: 100%;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"third": "MhGIN",
	"content": "_3NSvX",
	"cardContainer": "_6ZLaK",
	"logo": "TLwDt",
	"sectionHeading": "WkvFb",
	"cardContents": "Ir5WH"
};
export default ___CSS_LOADER_EXPORT___;
